import "@fontsource/roboto";
import "@fontsource/roboto/900.css";
import "@fontsource/fjalla-one";
import "./src/styles/global.css";

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  /** Prevent scrolling behavior on destinations page when searching **/
  const isDestinationsPage = location.pathname === "/destinations/";

  return !isDestinationsPage;
};
